import { API_ENDPOINT } from './Api';
import requestInstance from './Request';
import { setCurrentUser } from 'utils/utils';

let env = process.env.REACT_APP_B2B_API_BASE_URL;

export const rateCardApi = async (data) => {
  let url = '';

  const payload = {
    dutyType: data?.type || data?.dutyTypeId,
    carType: data?.carType || data?.carId || data?.vehicleCategoryId,
  };

  if (data?.contractId) {
    url = `${env}${API_ENDPOINT.RateCard.api}?&tripType=${payload?.dutyType}&contractId=${data?.contractId}&carType=${payload?.carType}&location=${data?.location}&subLocation=${data?.subCity || ""}`;
  } else if (data?.rateCardId) {
    url = `${env}${API_ENDPOINT.RateCard.api}?&tripType=2&companyId=${data?.rateCardId}`;
  } else {
    url = `${env}${API_ENDPOINT.RateCard.api}?carType=${data?.carId}&type=${data?.type}&location=${data?.location}`;
  }
  const res = await requestInstance.get(url, data).catch((err) => err.response);
  return setCurrentUser(res);
};

export const postRateCardApi = async (data) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.RateCard.api}`, data)

    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const getTripPriceApi = async (data) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.RateCard.tripPriceApi}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const getCompanyLocation = async (data) => {
  const payload = {
    contractId: data,
  };

  const url = `${env}${API_ENDPOINT.RateCard.companyLocation}?contractId=${payload?.contractId}`;
  const res = await requestInstance.get(url, data).catch((err) => err.response);
  return setCurrentUser(res);
};

export const getCompanyDutyType = async (data) => {
  const payload = {
    contractId: data?.contractId,
    location: data?.location,
  };

  const url = `${env}${API_ENDPOINT.RateCard.companyDuty}?&contractId=${payload?.contractId}&location=${data?.location}`;
  const res = await requestInstance.get(url, data).catch((err) => err.response);
  return setCurrentUser(res);
};

export const getSubCityNames = async (data) => {

  const url = `${env}${API_ENDPOINT.RateCard.subCity}?cityId=${data}`;
  const res = await requestInstance.get(url, data).catch((err) => err.response);
  return setCurrentUser(res);
};